import { Link } from "react-router-dom";
export default function MasterCourses() {
  window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <>
      <>
        <div className="page-head">
          <div className="container">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/all_courses">Courses</Link>
              </li>
              <li className="breadcrumb-item active">Master Course</li>
            </ol>
            <span className="level-pill beginner">Beginners</span>
            <h1>Master Course</h1>
            <p className="text-mono" style={{ color: "#B9C0F0" }}>
              Step-by-step stock market training for beginners — build strong
              fundamentals, learn to trade.
            </p>
          </div>
        </div>
        <section className="section">
          <div className="container">
            <div className="row bg-paper rounded py-3 mx-0 mb-5">
              <div className="col-6 col-md-3 mb-3">
                <div className="stat-block" style={{ padding: ".8rem" }}>
                  <strong style={{ fontSize: "1.2rem" }}>Beginners</strong>
                  <span>Level</span>
                </div>
              </div>
              <div className="col-6 col-md-3 mb-3">
                <div className="stat-block" style={{ padding: ".8rem" }}>
                  <strong style={{ fontSize: "1.2rem" }}>3 Months</strong>
                  <span>Duration</span>
                </div>
              </div>
              <div className="col-6 col-md-3 mb-3">
                <div className="stat-block" style={{ padding: ".8rem" }}>
                  <strong style={{ fontSize: "1.2rem" }}>2 Hours</strong>
                  <span>Daily Class</span>
                </div>
              </div>
              <div className="col-6 col-md-3 mb-3">
                <div className="stat-block" style={{ padding: ".8rem" }}>
                  <strong style={{ fontSize: "1.2rem" }}>Eng / Hindi</strong>
                  <span>Language</span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-7">
                <h2>Course Description</h2>
                <p className="text-muted-soft">
                  The L2E Master Course is designed for beginners and aspiring
                  traders who want to build a strong foundation in stock market
                  trading and investing. You'll learn stock market basics,
                  technical &amp; fundamental analysis, and trading psychology —
                  whether you're a student, employee, trader, entrepreneur or
                  homemaker, this program helps you trade confidently and grow
                  wealth consistently.
                </p>
                <div className="cus-scroll-view-1">
                  <h2 className="mt-5">Course Modules</h2>
                  <ul className="mod-list">
                    <li>
                      <span className="mod-num">01</span>
                      <div>
                        <h5>Equity Market</h5>
                        <p>Basics, trading accounts, placing orders</p>
                      </div>
                    </li>
                    <li>
                      <span className="mod-num">02</span>
                      <div>
                        <h5>Derivatives (F&amp;O)</h5>
                        <p>Futures &amp; options for trading and hedging</p>
                      </div>
                    </li>
                    <li>
                      <span className="mod-num">03</span>
                      <div>
                        <h5>Technical Analysis</h5>
                        <p>Charts, candlesticks, patterns, indicators</p>
                      </div>
                    </li>
                    <li>
                      <span className="mod-num">04</span>
                      <div>
                        <h5>Fundamental Analysis</h5>
                        <p>Company financials &amp; stock valuation</p>
                      </div>
                    </li>
                    <li>
                      <span className="mod-num">05</span>
                      <div>
                        <h5>Intraday Trading</h5>
                        <p>Fast-paced strategies for daily setups</p>
                      </div>
                    </li>
                    <li>
                      <span className="mod-num">06</span>
                      <div>
                        <h5>Swing Trading</h5>
                        <p>Trade weekly price movements confidently</p>
                      </div>
                    </li>
                    <li>
                      <span className="mod-num">07</span>
                      <div>
                        <h5>Long-Term Investment</h5>
                        <p>Wealth creation strategies</p>
                      </div>
                    </li>
                    <li>
                      <span className="mod-num">08</span>
                      <div>
                        <h5>Mutual Funds &amp; SIPs</h5>
                        <p>Smart diversification</p>
                      </div>
                    </li>
                    <li>
                      <span className="mod-num">09</span>
                      <div>
                        <h5>Trading Psychology</h5>
                        <p>Control emotions during trades</p>
                      </div>
                    </li>
                    <li>
                      <span className="mod-num">10</span>
                      <div>
                        <h5>Risk Management</h5>
                        <p>Capital protection &amp; stop-loss planning</p>
                      </div>
                    </li>
                    <li>
                      <span className="mod-num">11</span>
                      <div>
                        <h5>Portfolio Diversification</h5>
                        <p>Balance risk for best returns</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-5 mt-5 mt-lg-0">
                <div className="form-panel">
                  <h4>Who Should Enroll?</h4>
                  <ul
                    className="mt-3"
                    style={{ listStyle: "none", padding: 0 }}
                  >
                    <li className="py-2 border-bottom">
                      Students &amp; Freshers
                    </li>
                    <li className="py-2 border-bottom">
                      Working Professionals
                    </li>
                    <li className="py-2 border-bottom">
                      Investors &amp; Traders
                    </li>
                    <li className="py-2 border-bottom">Business Owners</li>
                    <li className="py-2">Homemakers &amp; Retirees</li>
                  </ul>
                  <hr />
                  <h4>Why Choose This Course?</h4>
                  <ul
                    className="mt-3"
                    style={{ listStyle: "none", padding: 0, fontSize: ".9rem" }}
                  >
                    <li className="py-1">✓ Learn from Industry Experts</li>
                    <li className="py-1">
                      ✓ Beginner-Friendly Complete Curriculum
                    </li>
                    <li className="py-1">
                      ✓ Trading Psychology &amp; Discipline
                    </li>
                    <li className="py-1">✓ Risk Management Strategies</li>
                    <li className="py-1">✓ SEBI-Compliant Trading Approach</li>
                  </ul>
                  <a
                    href="https://wa.me/7004654910?text=Hi%2C%20I%20saw%20your%20website%2C%20I%27m%20interested%20in%20the%20Master%20Course.%20Could%20you%20share%20more%20details%3F"
                    className="btn btn-brass btn-block mt-4"
                    target="_blank"
                    rel="noopener"
                  >
                    Book FREE Demo Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    </>
  );
}
